import { FileEarmarkText } from "react-bootstrap-icons";
import { ModuleList } from "../interfaces/modules.interface";

/*---------------- Módulo Sumaleasing ----------------*/
import SumaleasingContracts from "./sumaleasing/pages/Contracts";
import ContractView from "./sumaleasing/pages/ContractView";
/*----------------------------------------------------*/

/**
 * Lista de rutas para cada extensión activa en el ERP.
 * Cada extensión contiene un nombre, sección visible, y sus rutas correspondientes.
 */
export const AppModules: ModuleList = [
    {
        name: "sumaleasing",
        section: "Sumaleasing",
        paths: [
            {
                title: "Contratos",
                path: "/sumaleasing/Contratos",
                icon: FileEarmarkText,
                component: SumaleasingContracts,
                innerPaths: [
                    {
                        path: "/sumaleasing/Contrato/:id",
                        component: ContractView
                    }
                ]
            }
        ]
    }
];